export default __webpack_public_path__ + "static/media/avatar.0bc27700.svg";